import React from "react";

import { useFormData } from "@sp-state/useFormData";
import AutosuggestionInput from "../../../shared/AutosuggestionInput";
import InputWrapper from "../InputWrapper";
import OtherProfessionQuery from "../../../../assets/StaticQueries/OtherProfession.query";

import styles from "./OtherProfessionsInput.module.scss";

const OtherProfessionsInput: React.FC = () => {
  const autosuggestionList = OtherProfessionQuery();

  const { profession, otherProfession, setError, setIsValid, setValue } =
    useFormData(state => state);

  const INPUT_NAME = "otherProfession";

  const onSetError = ({ hasError }: { hasError: boolean }) => {
    setError(INPUT_NAME, hasError);
  };

  const onSetValue = (val: string) => {
    if (otherProfession.hasError) setError(INPUT_NAME, false);

    setValue(INPUT_NAME, val.toLowerCase());

    if (val.length < 3) {
      setIsValid("profession", false);
      setIsValid(INPUT_NAME, false);

      return;
    }

    setIsValid("profession", true);
    setIsValid(INPUT_NAME, true);
  };

  return (
    <div className={styles.otherProfessionsInput}>
      {profession.value === "7" && (
        <InputWrapper label="If other, please enter the title of your profession.">
          <AutosuggestionInput
            errorMsg="Please enter a valid profession."
            inputClassName={`${styles.field} ${
              otherProfession.hasError && styles.error
            }`}
            externalValue={otherProfession.value}
            listItems={autosuggestionList as AutosuggestionInput.ListItem[]}
            onSetError={onSetError}
            onSetValue={onSetValue}
            externalIsValid={otherProfession.isValid}
          />
        </InputWrapper>
      )}
    </div>
  );
};

export default OtherProfessionsInput;
